{
  "name": "vsd-agenda",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "check-node": "chmod +x ./scripts/check-node.sh && ./scripts/check-node.sh",
    "dev": "npm run check-node && ng serve",
    "prod": "npx http-server -p 8080 -c-1 dist/build",
    "start": "npm run check-node && ng serve",
    "build": "npm run check-node && ng build",
    "watch": "ng build --watch --configuration development",
    "test": "jest --force-exit --verbose",
    "test:watch": "npm run test -- --watch",
    "test:coverage": "npm run test -- --coverage",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "prepare": "npm run check-node && husky",
    "prettier": "prettier --check .",
    "prettier:fix": "prettier --write .",
    "sonar-scanner": "node_modules/sonar-scanner/bin/sonar-scanner -Dsonar.login=1734d1fa1c7a7cc636d234e84604dd41837c1112 -Dsonar.host.url=http://192.168.10.146:9000 -Dsonar.projectKey=vsd-agenda",
    "g": "plop --plopfile=.template/plopfile.js",
    "dev:open": "npm run check-node && ng serve --host 0.0.0.0 --disable-host-check"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~19.0.0",
    "@angular/cdk": "~19.0.0",
    "@angular/common": "~19.0.0",
    "@angular/compiler": "~19.0.0",
    "@angular/core": "~19.0.0",
    "@angular/forms": "~19.0.0",
    "@angular/platform-browser": "~19.0.0",
    "@angular/platform-browser-dynamic": "~19.0.0",
    "@angular/router": "~19.0.0",
    "@angular/service-worker": "~19.0.0",
    "@fullcalendar/angular": "^6.1.20",
    "@fullcalendar/core": "^6.1.20",
    "@fullcalendar/daygrid": "^6.1.20",
    "@fullcalendar/interaction": "^6.1.20",
    "@fullcalendar/list": "^6.1.20",
    "@fullcalendar/timegrid": "^6.1.20",
    "@primeuix/themes": "^2.0.3",
    "@tailwindcss/postcss": "^4.1.18",
    "@videosoft/vs-auth": "^2.1.0",
    "chart.js": "^4.5.1",
    "dexie": "^4.0.11",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "^1.13.12",
    "postcss": "^8.5.6",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.4",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.18",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "19.0.0",
    "@angular-eslint/eslint-plugin": "19.0.0",
    "@angular-eslint/eslint-plugin-template": "19.0.0",
    "@angular-eslint/schematics": "19.0.0",
    "@angular-eslint/template-parser": "19.0.0",
    "@angular/build": "^19.2.19",
    "@angular/cli": "~19.0.0",
    "@angular/compiler-cli": "~19.0.0",
    "@types/jest": "^29.5.14",
    "@types/node": "^22.10.2",
    "@typescript-eslint/eslint-plugin": "8.18.1",
    "@typescript-eslint/parser": "8.18.1",
    "eslint": "^9.17.0",
    "husky": "^9.1.7",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.4.2",
    "plop": "^4.0.1",
    "prettier": "^3.4.2",
    "sonar-scanner": "^3.1.0",
    "typescript": "~5.6.3",
    "ulid": "^2.3.0"
  }
}
